import React from "react";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

export const TRMargenConceptoConsolidado = ({
  linea,
  className,
  classNameTitulo,
  data,
  prop = "utilidad_bruta",
  formatodinero = false,
  operador = "%",
  guia,
  concepto,
  color
}) => {
  const getValue = (idadr, idsucursal) => {
    try {
      var result = data.filter(
        (element) =>
          element.idadr === idadr && element.idsucursal === idsucursal
      )[0][prop];

      if (formatodinero) {
        return FormatMoney(result, 0);
      }
      else {
        return result;
      }

    } catch {
      return 0;
    }
  };

  const getGuia = (concepto) => {
    try {
      var result = guia.filter(
        (element) =>
          element.concepto === concepto
      )[0].guia;
      if (formatodinero) {
        return FormatMoney(result, 0);
      }
      else {
        return result;
      }
    } catch {
      return 0;
    }
  };

  const Getcolor = (color, dato, datoguia) => {
    // Convertir los valores a números eliminando comas
    const numDato = parseFloat(dato.toString().replace(/,/g, ""));
    const numDatoguia = parseFloat(datoguia.toString().replace(/,/g, ""));
  
    if (numDato !== 0) {
      if (color === "menos") {
        return numDato < numDatoguia ? "red" : "";
      } else if (color === "mas") {
        return numDato > numDatoguia ? "red" : "";
      }
    }
    return "";
  };
  
  return (
    <tr>
      <td className={classNameTitulo}>{linea}</td>
      <td className={`${className} ta-center sticky-row-guia-80`}>{getGuia(concepto)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(0, 0), getGuia(concepto))}`} >{getValue(0, 0)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 0), getGuia(concepto))}`}>{getValue(1, 0)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(2, 0), getGuia(concepto))}`}>{getValue(2, 0)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 1), getGuia(concepto))}`}>{getValue(1, 1)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 21), getGuia(concepto))}`}>{getValue(1, 21)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 41), getGuia(concepto))}`}>{getValue(1, 41)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 51), getGuia(concepto))}`}>{getValue(1, 51)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(2, 2), getGuia(concepto))}`}>{getValue(2, 2)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(2, 22), getGuia(concepto))}`}>{getValue(2, 22)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(2, 32), getGuia(concepto))}`}>{getValue(2, 32)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(2, 12), getGuia(concepto))}`}>{getValue(2, 12)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 11), getGuia(concepto))}`}>{getValue(1, 11)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 31), getGuia(concepto))}`}>{getValue(1, 31)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(1, 61), getGuia(concepto))}`}>{getValue(1, 61)}{operador}</td>
      <td className={`${className} ta-center ${Getcolor(color, getValue(2, 52), getGuia(concepto))}`}>{getValue(2, 52)}{operador}</td>
    </tr>
  );
};
